import * as React from "react"
import {ButtonIconSeeker} from "@ui-seeker/core";

import {useRepricingFormData} from "../../@hooks";


export default function RepricingFormScopeRemoveButton({ criterion }) {
	const { handleRemoveScope } = useRepricingFormData(criterion)

	return <ButtonIconSeeker
		icon="trash-can"
		iconWeight="light"
		iconProps={{ color: 'text.disabled' }}
		onClick={handleRemoveScope}
	/>
}